import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { RouteExecutor } from '../../@core/application-router/route.executor';
import { ApplicationRouterService } from '../../@core/application-router/application-router.service';
import { MarcheAPIService } from '../../@core/api/marche-api.service';
import {
    Filters,
    LPContent,
    LPContentItem,
    LPHeader,
    LPSEO,
    TableData,
} from './listing-page.data';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../../@shared/models/response-wrapper.model';
import { plainToClass, plainToClassFromExist } from 'class-transformer';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FunctionModel } from '../../@shared/models/function.model';
import { FormControl } from '@angular/forms';
import { SeoService } from '../../@core/seo.service';
import { ListingPageService } from '../listing-page.service';
import { DOCUMENT } from '@angular/common';
import { AppService } from '../../app.service';
import { stringify } from 'querystring';
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';
import { FooterPageService } from '../../footer/footer-page.service';
import { AnalyticsService } from '../../@core/analytics.service';
import { OfferToggleService } from '../../offer-toggle/offer-toggle.service';
import { FooterV2Service } from 'src/app/footer-v2/footer-v2.service';

@Component({
    selector: 'app-listing-page',
    templateUrl: './listing-page.component.html',
    styleUrls: ['./listing-page.component.scss'],
    animations: [
        trigger('pushFilter', [
            state(
                'show',
                style({
                    width: '35%',
                })
            ),
            state(
                'hide',
                style({
                    width: '0',
                })
            ),
            transition('show => hide', animate('200ms ease-in-out')),
            transition('hide => show', animate('200ms ease-in-out')),
        ]),
        trigger('pushModel', [
            state(
                'show',
                style({
                    width: '30%',
                    opacity: 1,
                })
            ),
            state(
                'hide',
                style({
                    width: '0',
                    opacity: 0,
                })
            ),
            transition('show => hide', animate('200ms ease-in-out')),
            transition('hide => show', animate('200ms ease-in-out')),
        ]),

        trigger('slideInOut', [
            state(
                'show',
                style({
                    width: '40px',
                })
            ),
            state(
                'hide',
                style({
                    width: '40px',
                })
            ),
            transition('show => hide', animate('400ms ease-in-out')),
            transition('hide => show', animate('400ms ease-in-out')),
        ]),

        trigger('slideModelInOut', [
            state(
                'show',
                style({
                    width: '300px',
                })
            ),
            state(
                'hide',
                style({
                    width: '40px',
                })
            ),
            transition('show => hide', animate('400ms ease-in-out')),
            transition('hide => show', animate('400ms ease-in-out')),
        ]),
    ],
})
export class ListingPageComponent
    extends RouteExecutor
    implements OnInit, AfterViewInit, OnChanges
{
    static readonly LP_HEADER_API = '/lp/header/v2';
    static readonly LP_SEO_API = '/lp/seo';
    static readonly LP_FILTERS_API = '/lp/filters';
    static readonly REQ_FILTER_PAGE = '/rfp';

    static readonly COLP_HEADER_API = '/clp/header/v2';
    static readonly COLP_SEO_API = '/clp/seo';
    static readonly COLP_FILTERS_API = '/clp/filters';

    collectionListingVisible = false;

    fireChanges = false;
    page = 0;
    errors: ErrorWrapper[] = [];
    @Input() filters: { [p: string]: string | string[] } = {};
    headerData: LPHeader = new LPHeader();
    contentItems: LPContent = {};
    filterData: Filters = new Filters();
    loading = true;
    nextPageLoading = false;
    noDataLeft = false;
    headerGhosts: Array<any> = [];
    contentGhosts: Array<any> = [];
    errorCaught = false;
    currentUrl: string | null = null;
    previousUrl: string | null = null;
    footerContent = '';
    seoTable: TableData | undefined;
    showHeaderShimmer = true;
    showShimmer = true;
    ssUrl = '';
    bannerCount = 0;

    initialProductsCount?: number = 0;
    scrollTopButton = false;
    modelVisible = false;
    brandModelDiv = false;
    filterSortDiv = false;
    rfpFilter: { [p: string]: string | string[] } = {};

    brand = new FormControl('');
    model = new FormControl('');

    ids: Array<string> = [];
    presen = 24;
    isTimerStrip = false;
    isTimerStripV2 = false;

    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        private el: ElementRef,
        private router: Router,
        private seoService: SeoService,
        private listingPageService: ListingPageService,
        private appService: AppService,
        private footerService: FooterPageService,
        private analyticsService: AnalyticsService,
        private OfferToggleService: OfferToggleService,
        private footerV2service: FooterV2Service,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(applicationRouterService);
        if (
            this.router.routerState.snapshot.url
                .toString()
                .split('?')[0]
                .includes('clp')
        ) {
            this.collectionListingVisible = true;
        }
        const url = this.router.routerState.snapshot.url
            .toString()
            .split('/')[1];
        this.ids.push(url);
        const params = this.activatedRoute.snapshot.params;

        if (params?.id1) {
            this.ids.push(params?.id1);
        }
        if (params?.id2) {
            this.ids.push(params?.id2);
        }

        const distinctArray = this.ids.filter(
            (n, i) => this.ids.indexOf(n) === i
        );
        this.ssUrl = distinctArray.join('/');
        this.activatedRoute.queryParams.subscribe(param => {
            this.filters = param;
            this.filterSortDiv = param.sidebar === 'true' ? true : false;
            this.noDataLeft = false;
            this.loading = true;
            this.page = 0;
            this.showGhosts('content', 10);

            this.contentItems = {};
            this.errors = [];
            if (
                this.listingPageService.getCurrentPage() !== -1 &&
                stringify(this.filters) ===
                    stringify(this.listingPageService.getFilters())
            ) {
                this.page = this.listingPageService.getCurrentPage();
                // If scroll position is saved for the current page, restore it
                const savedScrollPos =
                    this.listingPageService.getScrollPosition(this.page);
                console.log(savedScrollPos, 'back-1');
                if (savedScrollPos !== undefined) {
                    // Use a timeout to ensure that scrolling occurs after rendering
                    setTimeout(() => {
                        window.scrollTo(0, savedScrollPos);
                    });
                }
            }
            this.processLink('/fn/internal?page=lp&action=nav-update');
            this.processLink('/fn/internal?value=false&action=nav-toggle');
            this.processLink('/fn/internal?value=true&action=category-toggle');
            this.updateListingHeadersData();
            this.updateListingContentData(this.page);
            this.updateListingFilterData();
            this.updateSeo();
            this.footerService.updateFilter({ ...this.filters, page: 'lp' });
            this.OfferToggleService.OfferToggle({
                ...this.filters,
                page: 'lp',
            });
            this.brandModelDiv = false;
            this.currentUrl = this.router.url;
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.previousUrl = this.currentUrl;
                    this.currentUrl = event.url;
                    if (
                        this.previousUrl?.includes('/dp') &&
                        this.currentUrl?.includes('/lp')
                    ) {
                    }
                }
            });
        });
    }
    private layoutBasedFlex: Record<string, string> = {
        center: '0 0 40%',
        'center-center': '0 0 100%',
        'center-start': '0 0 40%',
        default: '0 0 40%',
    };
    private layoutBasedOrder: Record<string, string> = {
        'center-end': '1',
        'end-center': '1',
        'center-start': '0',
        'end-start': '1',
        default: '0',
    };
    ngOnInit(): void {
        this.showHeaderShimmer = true;
        this.showGhosts('circle', 4);
    }

    private updateListingHeadersData() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<LPHeader> | null>(
                this.collectionListingVisible
                    ? ListingPageComponent.COLP_HEADER_API
                    : ListingPageComponent.LP_HEADER_API,
                { ...this.filters, ss: this.ssUrl }
            )
            .subscribe(
                value => {
                    if (value?.success) {
                        this.headerData = plainToClass(LPHeader, value.data);
                        this.showHeaderShimmer = false;
                        this.hideGhosts('circle');
                        if (
                            this.headerData.timerStrip?.layout == 'timer-strip'
                        ) {
                            this.startTimer(this.headerData.timerStrip.endsIn);
                            this.isTimerStrip = this.isfutureDateGreter(
                                this.headerData.timerStrip.endsIn
                            );
                        }
                        if (
                            this.headerData.timerStrip?.layout ==
                            'timer-strip-v2'
                        ) {
                            this.startTimerV2(
                                this.headerData.timerStrip.endsIn
                            );
                            this.isTimerStripV2 = this.isfutureDateGreter(
                                this.headerData.timerStrip.endsIn
                            );
                        }
                    } else {
                        this.errorCaught = true;
                        plainToClassFromExist(this.errors, value?.errors);
                        this.headerData = new LPHeader();
                    }
                },
                error => {},
                () => {
                    this.showHeaderShimmer = false;
                }
            );
    }

    private updateListingContentData(page: number) {
        this.listingPageService
            .getListingData(this.filters, page, this.collectionListingVisible)
            .subscribe(
                res => {
                    if (res.success) {
                        this.loading = false;
                        this.errors = [];
                        if (page === 0) {
                            this.contentItems = res.data;
                            this.initialProductsCount =
                                this.contentItems?.feed?.filter(
                                    item => item.layout === 'square'
                                ).length;
                            this.errorCaught = false;
                        } else {
                            if (res.data?.cached) {
                                this.contentItems = res.data;
                            }
                            this.nextPageLoading = false;
                            if (res.data?.feed?.length === 0) {
                                this.noDataLeft = true;
                            } else {
                                if (!res.data?.cached) {
                                    this.contentItems?.feed?.push(
                                        ...res?.data?.feed
                                    );
                                }
                            }
                        }
                        if (this.contentItems?.feed) {
                            this.page = !!this.initialProductsCount
                                ? Math.ceil(
                                      this.contentItems?.feed.filter(
                                          item => item.layout === 'square'
                                      ).length / this.initialProductsCount
                                  )
                                : page + 1;
                        }
                        this.bannerCount = this.contentItems?.feed
                            ? this.contentItems?.feed.filter(
                                  item => item.layout === 'listing-banner'
                              ).length
                            : 0;
                        // this.createDummyContentItems();
                    } else {
                        this.loading = false;
                        this.noDataLeft = true;
                        this.errors = res.errors;
                        this.errorCaught = true;
                    }
                },
                error => {},
                () => {
                    this.hideGhosts('content');
                }
            );
    }

    private updateListingFilterData() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<Filters> | null>(
                this.collectionListingVisible
                    ? ListingPageComponent.COLP_FILTERS_API
                    : ListingPageComponent.LP_FILTERS_API,
                this.filters
            )
            .subscribe(
                value => {
                    if (value?.success) {
                        this.filterData = plainToClass(Filters, value.data);
                    } else {
                        // this.errors = plainToClass(
                        //     ErrorWrapper,
                        //     value.errors
                        // );
                    }
                },
                error => {},
                () => {}
            );
    }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        switch (query?.action) {
            case 'pagination':
                {
                    this.page = +query?.f.toString();
                    this.updateListingContentData(+this.page);
                    this.nextPageLoading = true;
                }
                break;
            case 'nav-update':
                {
                    super.executeFunctionLink(id, query);
                }
                break;
            case 'nav-toggle':
                {
                    super.executeFunctionLink(id, query);
                }
                break;
            case 'scroll-to-top':
                {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                }
                break;

            default: {
                this.loading = true;
                this.applicationRouterService
                    .executeFunctionLink(id, query)
                    .subscribe(res => {
                        this.updateState(res.data);
                        this.loading = false;
                    });
            }
        }
    }

    externalLinksRedirect(link: string) {
        console.log(link);
        window.open(link, '_blank');
    }
    executePageLink(
        pageId: string,
        query: { [p: string]: string | string[] },
        params?: any
    ) {
        switch (pageId) {
            case '/rfp':
                {
                    this.rfpFilter = query;
                }
                break;
            default: {
                this.listingPageService.setScrollPosRestore(
                    // @ts-ignore
                    this.document.scrollingElement.scrollTop
                );
                super.executePageLink(pageId, query, params);
            }
        }
    }

    updateState(response: FunctionModel) {
        this.contentItems?.feed
            ?.filter(item => item.id === response.indexId)
            .forEach(item => {
                const updateId = response.updateId;
                item.button.icon = response.state.icon;
                item.button.link = response.state.link;
                item.button.future = response.state.future;
            });
        this.fireChanges = !this.fireChanges;
    }

    backButton() {
        window.history.back();
    }

    openBrandModel() {
        this.brandModelDiv = !this.brandModelDiv;
        if (this.brandModelDiv) {
            // @ts-ignore
            this.processLink(this.headerData.action.link);
        }
    }

    get stateModelChangeName() {
        return this.brandModelDiv ? 'show' : 'hide';
    }

    openFilterSort() {
        this.filterSortDiv = !this.filterSortDiv;
    }

    get stateFilterName() {
        return this.filterSortDiv ? 'show' : 'hide';
    }

    showGhosts(value: string, size?: number) {
        switch (value) {
            case 'circle':
                {
                    this.headerGhosts = new Array(size);
                }
                break;
            case 'content':
                {
                    this.contentGhosts = new Array(size);
                }
                break;
            default: {
                this.headerGhosts = new Array(4);
                this.contentGhosts = new Array(10);
            }
        }
    }

    hideGhosts(value?: string) {
        switch (value) {
            case 'circle':
                {
                    this.headerGhosts = [];
                }
                break;
            case 'content':
                {
                    this.contentGhosts = [];
                }
                break;
            default: {
                this.headerGhosts = [];
                this.contentGhosts = [];
            }
        }
    }

    ngAfterViewInit() {
        if (this.listingPageService.getScrollPos(this.filters) !== null) {
            window.scrollTo({
                top: this.listingPageService.getScrollPos(this.filters),
                behavior: 'auto',
            });
        }
    }

    updateSeo() {
        this.marcheAPIService
            .getRequest<ResponseWrapper<LPSEO>>(
                this.collectionListingVisible
                    ? ListingPageComponent.COLP_SEO_API
                    : ListingPageComponent.LP_SEO_API,
                {
                    ...this.filters,
                    ss: this.ssUrl,
                }
            )
            .subscribe(res => {
                if (res?.success) {
                    this.seoTable = res?.data?.seoTable;
                    this.footerContent = res?.data?.footerContent;
                    this.seoService.updateMetaTitle(res?.data?.meta?.title);
                    this.seoService.updateMetaDescription(
                        res?.data?.meta?.description
                    );
                    this.seoService.updateCanonical(res?.data?.canonical);
                    this.seoService.cacheSingleUrl(
                        window.location.host + res?.data?.canonical
                    );
                    this.seoService.updateHREFLang(res?.data?.langAlternates);

                    this.seoService.updateOgImage(res?.data.ogImage);
                    if (res?.data?.faq.length > 0) {
                        this.seoService.createGoogleFaqRichSnippet(
                            res?.data?.faq
                        );
                    }

                    // this.footerService.flushBreadcrumb();
                    this.footerV2service.flushBreadcrumb();
                    this.seoService.addRobotTag(res?.data?.meta?.robotTag);
                    if (!!res?.data?.breadCrumbs) {
                        this.seoService.updateBreadcrums(
                            res?.data?.breadCrumbs
                        );
                        this.footerV2service.breadcrumb.emit(
                            res?.data?.breadCrumbs
                        );
                    }
                }
            });
    }

    getWidthOnMobileItem(value: string) {
        switch (value) {
            case 'square':
                return 49;
            case 'listing-banner':
                return 100;
            default:
                return 0;
        }
    }
    getWidthOfItem(value: string) {
        switch (value) {
            case 'square':
                return 25;
            case 'listing-banner':
                return 50;
            default:
                return 0;
        }
    }

    /*createDummyContentItems() {
      let dummyItems =
          (this.contentItems?.feed.length -
              this.bannerCount +
              this.bannerCount * 2) %
          4;
      while (dummyItems > 0) {
          this.contentItems?.feed.push(new LPContentItem());
          dummyItems--;
      }
  }*/

    ngOnChanges(changes: SimpleChanges) {}

    getFlex(item: any): string {
        return (
            this.layoutBasedFlex[item.alignment] || this.layoutBasedFlex.default
        );
    }

    getFlexOrder(item: any) {
        return (
            this.layoutBasedOrder[item?.alignment] ||
            this.layoutBasedOrder.default
        );
    }
    day: number = 0;
    hours: number = 0;
    mins: number = 0;
    seconds: number = 0;
    interval: any;

    startTimer(endInDate: string): string {
        this.interval = setInterval(() => {
            var futureDate = new Date(endInDate).getTime();
            var Today = new Date().getTime();
            var distance = futureDate - Today;
            var second = distance / 1000;
            var d = Math.floor(second / (3600 * 24));
            var h = Math.floor((second % (3600 * 24)) / 3600);
            var m = Math.floor((second % 3600) / 60);
            var s = Math.floor(second % 60);
            this.hours = d * 24 + h;
            this.mins = m;
            this.seconds = s;
            if (Today < 0) {
                clearInterval(this.interval);
            }
            if (!this.isfutureDateGreter(endInDate)) {
                this.isTimerStrip = false;
            }
        }, 1000);
        return '';
    }

    startTimerV2(endInDate: string): string {
        this.interval = setInterval(() => {
            var futureDate = new Date(endInDate).getTime();
            var Today = new Date().getTime();
            var distance = futureDate - Today;
            var second = distance / 1000;
            var d = Math.floor(second / (3600 * 24));
            var h = Math.floor((second % (3600 * 24)) / 3600);
            var m = Math.floor((second % 3600) / 60);
            var s = Math.floor(second % 60);

            // Check if hours exceed 24 and adjust day accordingly
            if (h >= 24) {
                d += Math.floor(h / 24);
                h = h % 24;
            }
            this.day = d;
            this.hours = h;
            this.mins = m;
            this.seconds = s;
            if (Today < 0) {
                clearInterval(this.interval);
            }
            if (!this.isfutureDateGreter(endInDate)) {
                this.isTimerStripV2 = false;
            }
        }, 1000);
        return '';
    }

    isfutureDateGreter(endInDate: string) {
        var futureDate = new Date(endInDate).getTime();
        var Today = new Date().getTime();
        return futureDate > Today;
    }

    ngOnDestroy(): void {
        // Save the scroll position before navigating away
        const currentScrollPos = window.scrollY || window.pageYOffset;
        this.listingPageService.setScrollPosition(this.page, currentScrollPos);
    }
}
